import React, { Component, useState } from "react";
import { cancelImage } from "../../../../assets";

function CanceledRequest(props) {
  const [showText, setShowText] = useState(false);
  return (
    <section className="main-content error-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-0 col-sm-4"></div>
          <div className="col-12 col-sm-4 text-center">
            <img onLoad={()=>setShowText(true)} src={cancelImage} alt="Canceled Request" title="Request has been canceled" />
            {showText && <>This Request has been canceled. Please contact the company at <a href="tel:+12138669988">213-866-9988</a> for more information.</>}
            {/* <div className="form-group button-wrapper">
              <button
                onClick={() => props.history.push("/")}
                className="custom-buton custom-buton-large w-100"
              >
                Go Back
              </button>
            </div> */}
          </div>
          <div className="col-0 col-sm-4"></div>
        </div>
      </div>
    </section>
  );
}

export default CanceledRequest;
